import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Output } from '@angular/core';
import { HubspotService } from '@services/hubspot/hubspot.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { OverflowShadowDirective } from '@shared/directives/overflow-shadow.directive';

interface Blog {
  featuredImage: string;
  publishDate: Date;
  name: string;
  postSummary: string;
  url: string;
}

@Component({
  selector: 'app-home',
  imports: [CommonModule, OverflowShadowDirective],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  @Output() dataChanged = new EventEmitter<string>();

  blogs: Blog[] = [];
  hubSpotService = inject(HubspotService);

  constructor() {
    this.hubSpotService
      .getBlog()
      .pipe(takeUntilDestroyed())
      .subscribe((blogs: Blog[]) => {
        this.blogs = blogs.map((blog: Blog) => ({
          ...blog,
          postSummary: this.cleanSummary(blog.postSummary),
        }));
        //this.blogs = blogs;
      });
  }

  private cleanSummary(html: string): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    doc.querySelectorAll('[style]').forEach((e) => {
      e.removeAttribute('style');
    });

    return doc.body.innerHTML;
  }
}
